import React from "react";

import Stack from "veneer/Stack";
import { Colors } from "veneer/Theme";
import Typography from "veneer/Typography";

import { StructuralWidgetProps, getWidgetConfigString } from "./widgetConfig";
import WidgetContainer from "../WidgetContainer";

interface QuickLink {
  label: string;
  url: string;
}

function getSafeLinkUrl(url: string) {
  const trimmedUrl = url.trim();
  if (
    trimmedUrl.startsWith("/") ||
    trimmedUrl.startsWith("https://") ||
    trimmedUrl.startsWith("http://")
  ) {
    return trimmedUrl;
  }
  return null;
}

export default function QuickLinksWidget({ config }: StructuralWidgetProps) {
  const title = getWidgetConfigString(config, "title", "Quick Links");
  const links = Array.isArray(config?.links)
    ? config.links.filter(
        (link): link is QuickLink =>
          typeof link === "object" &&
          link !== null &&
          typeof (link as Partial<QuickLink>).label === "string" &&
          typeof (link as Partial<QuickLink>).url === "string",
      )
    : [];

  return (
    <WidgetContainer title={title}>
      <Stack gap={1} px={1}>
        {links.length > 0 ? (
          links.map((link, index) => {
            const url = getSafeLinkUrl(link.url);
            return url ? (
              <a href={url} key={`${link.url}-${index}`}>
                {link.label}
              </a>
            ) : (
              <Typography
                color={Colors.gray700}
                key={`${link.url}-${index}`}
                variant="body2"
              >
                {link.label}
              </Typography>
            );
          })
        ) : (
          <Typography color={Colors.gray700} variant="body2">
            No links configured.
          </Typography>
        )}
      </Stack>
    </WidgetContainer>
  );
}
